@let perms = activeUserPermissionsAndRoles$();
<aside>
	<div
		class="sidenav-container"
		[class.collapsed]="isCollapsed()"
	>
		<!-- Backdrop for mobile -->
		<div
			class="sidenav-backdrop"
			[class.active]="showProfileDialog"
			(click)="closeAllDialogs()"
		></div>

		<!-- Main sidenav -->
		<div
			class="sidenav"
			[ngClass]="{collapsed: isCollapsed()}"
		>
			<!-- Header with logo and toggle button -->
			<dc-sidenav-header />

			<div class="splitter"></div>

			<!-- Search box -->
			<dc-sidenav-search />

			<div class="splitter"></div>

			<!-- Container for the menu sections -->
			<div class="sidenav-menu-sections">
				<!--			Top menu items-->
				<dc-sidenav-section section="top">
					<!-- Companies -->
					<dc-sidenav-item
						#adminCompanies="dcSidenavItem"
						id="admin-companies"
						label="struct.topbar.menuitems.companies"
						icon="fa-regular fa-building"
						route="admin"
						*permissionGuard="{
							allow: [PermissionType.sysadmin],
							denied: [],
						}"
						[pTooltip]="adminCompanies.label() | translate"
						[tooltipDisabled]="!isCollapsed()"
					/>

					<!-- Home -->
					<dc-sidenav-item
						#home="dcSidenavItem"
						id="home"
						label="struct.topbar.menuitems.home"
						icon="fa-regular fa-home"
						route="home"
						*permissionGuard="{
							allow: [PermissionType.permanent],
							denied: [PermissionType.sysadmin],
						}"
						[pTooltip]="home.label() | translate"
						[tooltipDisabled]="!isCollapsed()"
					/>

					<!-- Add New -->
					<dc-sidenav-items-group
						#addNew="dcSidenavItemsGroup"
						id="add-new"
						label="struct.topbar.menuitems.add"
						icon="fa-regular fa-plus"
						*permissionGuard="{
							allow: [PermissionType.cycle_create],
							denied: [PermissionType.sysadmin],
						}"
						[pTooltip]="addNew.label() | translate"
						[tooltipDisabled]="!isCollapsed()"
					>
						<!-- Create Cycle -->
						<dc-sidenav-item
							#createCycle="dcSidenavItem"
							route="cw/add-document/cycle"
							(click)="navTo('cw/add-document/cycle')"
							id="create-cycle"
							label="struct.topbar.menuitems.create-cycle"
							icon="fa-regular fa-file-edit"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="createCycle.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
						/>

						<!-- Create Template -->
						<dc-sidenav-item
							#createTemplate="dcSidenavItem"
							route="cw/add-document/template"
							(click)="navTo('cw/add-document/template')"
							id="create-template"
							label="struct.topbar.menuitems.create-template"
							icon="fa-regular fa-file-invoice"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="createTemplate.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
						/>

						<!-- Create Form -->
						<dc-sidenav-item
							#createForm="dcSidenavItem"
							route="cw/add-document/form"
							(click)="navTo('cw/add-document/form')"
							id="create-form"
							label="struct.topbar.menuitems.create-form"
							icon="fa-regular fa-file-lines"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="createForm.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
						/>
					</dc-sidenav-items-group>

					<!-- Documents -->
					@let cyclesCountMap = cyclesCountMap$();
					<dc-sidenav-items-group
						#documents="dcSidenavItemsGroup"
						id="documents"
						label="struct.sidenav.menuitems.category.documents"
						icon="fa-regular fa-file"
						*permissionGuard="{
							allow: [PermissionType.permanent],
							denied: [PermissionType.sysadmin],
						}"
						[pTooltip]="documents.label() | translate"
						[tooltipDisabled]="!isCollapsed()"
					>
						<!-- Cycles Draft -->
						<dc-sidenav-item
							#cyclesDraft="dcSidenavItem"
							id="cycles-draft"
							label="struct.topbar.menuitems.drafts"
							icon="fa-regular fa-file-edit"
							route="cycles/Draft"
							counterKey="Draft"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="cyclesDraft.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
							[counterValue]="cyclesCountMap.get(CycleListType.Draft)"
						/>

						<!-- Cycles Waiting -->
						<dc-sidenav-item
							#cyclesWaiting="dcSidenavItem"
							id="cycles-waiting"
							label="struct.topbar.menuitems.waitingForMe"
							icon="fa-regular fa-file-signature"
							route="cycles/Waiting"
							counterKey="Waiting"
							*permissionGuard="{
								allow: [PermissionType.cycle_sign],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="cyclesWaiting.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
							[counterValue]="cyclesCountMap.get(CycleListType.Waiting)"
						/>

						<!-- Cycles InProgress -->
						<dc-sidenav-item
							#cyclesInProgress="dcSidenavItem"
							id="cycles-inprogress"
							label="struct.topbar.menuitems.myCycles"
							icon="fa-regular fa-sync-alt"
							route="cycles/InProgress"
							counterKey="InProgress"
							*permissionGuard="{
								allow: [PermissionType.cycle_sign],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="cyclesInProgress.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
							[counterValue]="cyclesCountMap.get(CycleListType.InProgress)"
						/>

						<!-- Cycles Finished -->
						<dc-sidenav-item
							#cyclesFinished="dcSidenavItem"
							id="cycles-finished"
							label="struct.topbar.menuitems.finished"
							icon="fa-regular fa-flag-alt"
							route="cycles/Finished"
							counterKey="Finished"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="cyclesFinished.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
							[counterValue]="cyclesCountMap.get(CycleListType.Finished)"
						/>

						<!-- Cycles Signed -->
						<dc-sidenav-item
							#cyclesSigned="dcSidenavItem"
							id="cycles-signed"
							label="struct.topbar.menuitems.signed"
							icon="fa-regular fa-file-circle-check"
							route="cycles/Signed"
							counterKey="Signed"
							*permissionGuard="{
								allow: [PermissionType.cycle_create, PermissionType.cycle_sign],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="cyclesSigned.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
							[counterValue]="cyclesCountMap.get(CycleListType.Signed)"
						/>

						<!-- Cycles Rejected -->
						<dc-sidenav-item
							#cyclesRejected="dcSidenavItem"
							id="cycles-rejected"
							label="struct.topbar.menuitems.rejected"
							icon="fa-regular fa-person-circle-minus"
							route="cycles/Rejected"
							counterKey="Rejected"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="cyclesRejected.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
							[counterValue]="cyclesCountMap.get(CycleListType.Rejected)"
						/>

						<!-- Cycles Canceled -->
						<dc-sidenav-item
							#cyclesCanceled="dcSidenavItem"
							id="cycles-canceled"
							label="struct.topbar.menuitems.canceled"
							icon="fa-regular fa-user-times"
							route="cycles/Canceled"
							counterKey="Canceled"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="cyclesCanceled.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
							[counterValue]="cyclesCountMap.get(CycleListType.Canceled)"
						/>

						<!-- Cycles Archive -->
						<dc-sidenav-item
							#cyclesArchive="dcSidenavItem"
							id="cycles-archive"
							label="struct.topbar.menuitems.archive"
							icon="fa-regular fa-archive"
							route="cycles/Archive"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="cyclesArchive.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
							[counterValue]="cyclesCountMap.get(CycleListType.Archive)"
						/>
					</dc-sidenav-items-group>

					<!-- Templates -->
					<dc-sidenav-items-group
						#templates="dcSidenavItemsGroup"
						id="templates"
						label="struct.sidenav.menuitems.category.templates"
						icon="fa-regular fa-file-invoice"
						*permissionGuard="{
							allow: [PermissionType.permanent],
							denied: [PermissionType.sysadmin],
						}"
						[pTooltip]="templates.label() | translate"
						[tooltipDisabled]="!isCollapsed()"
					>
						<!-- Cycles Private Template -->
						<dc-sidenav-item
							#cyclesPrivateTemplate="dcSidenavItem"
							id="cycles-private-template"
							label="struct.topbar.menuitems.saved"
							icon="fa-regular fa-file"
							route="cycles/PrivateTemplate"
							counterKey="PrivateTemplate"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="cyclesPrivateTemplate.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
							[counterValue]="cyclesCountMap.get(CycleListType.PrivateTemplate)"
						/>

						<!-- Cycles Public Template -->
						<dc-sidenav-item
							#cyclesPublicTemplate="dcSidenavItem"
							id="cycles-public-template"
							label="struct.topbar.menuitems.publiccycles"
							icon="fa-regular fa-file-user"
							route="cycles/PublicTemplate"
							counterKey="PublicTemplate"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="cyclesPublicTemplate.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
							[counterValue]="cyclesCountMap.get(CycleListType.PublicTemplate)"
						/>
					</dc-sidenav-items-group>

					<!-- Forms -->
					<dc-sidenav-items-group
						#forms="dcSidenavItemsGroup"
						id="forms"
						label="struct.sidenav.menuitems.category.forms"
						icon="fa-regular fa-file-lines"
						*permissionGuard="{
							allow: [PermissionType.permanent, PermissionType.cycle_create],
							denied: [PermissionType.sysadmin],
						}"
						[pTooltip]="forms.label() | translate"
						[tooltipDisabled]="!isCollapsed()"
					>
						<!-- Cycles Private Form -->
						<dc-sidenav-item
							#cyclesPrivateForm="dcSidenavItem"
							id="cycles-private-form"
							label="struct.topbar.menuitems.privateforms"
							icon="fa-regular fa-file"
							route="cycles/PrivateForm"
							counterKey="PrivateForm"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="cyclesPrivateForm.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
							[counterValue]="cyclesCountMap.get(CycleListType.PrivateForm)"
						/>

						<!-- Cycles Public Form -->
						<dc-sidenav-item
							#cyclesPublicForm="dcSidenavItem"
							id="cycles-public-form"
							label="struct.topbar.menuitems.publicforms"
							icon="fa-regular fa-file-user"
							route="cycles/PublicForm"
							counterKey="PublicForm"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="cyclesPublicForm.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
							[counterValue]="cyclesCountMap.get(CycleListType.PublicForm)"
						/>

						<!-- Sent Mailing List -->
						<dc-sidenav-item
							#sentMailingList="dcSidenavItem"
							id="sent-mailing-list"
							label="struct.topbar.menuitems.inprogress-form"
							icon="fa-regular fa-sync-alt"
							route="sent-mailing-list"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="sentMailingList.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
						/>

						<!-- Build In Forms -->
						<dc-sidenav-item
							#buildInForms="dcSidenavItem"
							id="build-in-forms"
							label="struct.topbar.menuitems.build-in-forms"
							icon="fa-regular fa-building"
							route="build-in-forms"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
							}"
							[pTooltip]="buildInForms.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
						/>

						<!-- App Select Form -->
						<dc-sidenav-item
							#appSelectForm="dcSidenavItem"
							id="app-select-form"
							label="struct.topbar.menuitems.select-form-app"
							icon="fa-light fa-mobile"
							route="app/select-form"
							*permissionGuard="{
								allow: [PermissionType.cycle_create],
								denied: [PermissionType.sysadmin],
								pwaOnly: true,
							}"
							[pTooltip]="appSelectForm.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
						/>
					</dc-sidenav-items-group>
				</dc-sidenav-section>

				<!--			Bottom menu items-->
				<dc-sidenav-section section="bottom">
					<!-- Company Settings -->
					<dc-sidenav-item
						#companySettings="dcSidenavItem"
						id="company-settings"
						label="struct.topbar.menuitems.settings"
						icon="fa-regular fa-tools"
						route="company-settings"
						*permissionGuard="{
							allow: [PermissionType.users_manage],
							denied: [PermissionType.sysadmin],
						}"
						[pTooltip]="companySettings.label() | translate"
						[tooltipDisabled]="!isCollapsed()"
					/>

					<!-- System Settings -->
					<dc-sidenav-item
						#systemSettings="dcSidenavItem"
						id="system-settings"
						label="struct.topbar.menuitems.system-settings"
						icon="fa-regular fa-cog"
						route="system-settings"
						*permissionGuard="{
							allow: [PermissionType.sysadmin],
							denied: [],
						}"
						[pTooltip]="systemSettings.label() | translate"
						[tooltipDisabled]="!isCollapsed()"
					/>
					<!-- Swagger -->
					@if (perms.includes(PermissionType.admin) || perms.includes(PermissionType.sysadmin) || isDevMode()) {
						<dc-sidenav-item
							#swagger="dcSidenavItem"
							id="swagger"
							label="struct.topbar.menuitems.swagger"
							icon="fa-regular fa-database"
							route="swagger-ui"
							[pTooltip]="swagger.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
						/>
					}

					<!-- Dev Panel -->
					<dc-sidenav-item
						#devPanel="dcSidenavItem"
						id="dev-panel"
						label="dccomp.dev-panel.title"
						icon="fa-regular fa-code"
						route="dev-panel"
						*permissionGuard="{
							allow: isDevMode() || location.hostname.includes('.dev') ? [PermissionType.admin, UserRoleType.Superuser] : [PermissionType.admin],
							denied: [PermissionType.sysadmin],
						}"
						[pTooltip]="devPanel.label() | translate"
						[tooltipDisabled]="!isCollapsed()"
					/>

					<!-- Users -->
					<dc-sidenav-item
						#users="dcSidenavItem"
						id="users"
						label="struct.topbar.menuitems.users"
						icon="fa-regular fa-users-cog"
						route="users"
						*permissionGuard="{
							allow: [PermissionType.users_manage],
							denied: [PermissionType.sysadmin],
						}"
						[pTooltip]="users.label() | translate"
						[tooltipDisabled]="!isCollapsed()"
					/>

					<!-- Address Book -->
					<dc-sidenav-item
						#addressBook="dcSidenavItem"
						id="address-book"
						label="struct.topbar.menuitems.address-book"
						icon="fa-regular fa-address-book"
						route="users/address-book"
						*permissionGuard="{
							allow: [PermissionType.cycle_create],
							denied: [PermissionType.sysadmin],
						}"
						[pTooltip]="addressBook.label() | translate"
						[tooltipDisabled]="!isCollapsed()"
					/>

					<!-- Groups -->
					<dc-sidenav-item
						#groups="dcSidenavItem"
						id="groups"
						label="struct.topbar.menuitems.groups"
						icon="fa-regular fa-users"
						route="users/groups"
						*permissionGuard="{
							allow: [PermissionType.cycle_create],
							denied: [PermissionType.sysadmin],
						}"
						[pTooltip]="groups.label() | translate"
						[tooltipDisabled]="!isCollapsed()"
					/>

					<!-- Dev Panel -->
					@if (isDevMode() || location.hostname.includes('.dev') || location.hostname.includes('localhost')) {
						<dc-sidenav-item
							#devPanel="dcSidenavItem"
							id="dev-panel"
							label="dccomp.dev-panel.title"
							icon="fa-regular fa-code"
							route="dev-panel"
							[pTooltip]="devPanel.label() | translate"
							[tooltipDisabled]="!isCollapsed()"
						/>
					}
				</dc-sidenav-section>
			</div>

			<!-- Version info area -->
			<dc-sidenav-version-info />

			<!-- User profile area -->
			<dc-sidenav-user-profile />
		</div>
	</div>
</aside>
